import { render, staticRenderFns } from "./freeOrder.vue?vue&type=template&id=3b5990cd&scoped=true&"
import script from "./freeOrder.vue?vue&type=script&lang=js&"
export * from "./freeOrder.vue?vue&type=script&lang=js&"
import style0 from "./freeOrder.vue?vue&type=style&index=0&id=3b5990cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5990cd",
  null
  
)

export default component.exports